import { getLocalStorageData } from '../utils/storage/storage'

export const useGetLocalStorage = (key) => {
  const getItem = getLocalStorageData(key)
  if (!getItem) return {}
  const decodeParse = JSON.parse(atob(getItem))
  return decodeParse
}
